import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AccountDrawerService {
    private readonly _isOpen = signal(false);
    readonly isOpen = this._isOpen.asReadonly();

    open(): void { this._isOpen.set(true); }
    close(): void { this._isOpen.set(false); }

    /** Cierra sin animación de salida — usar al navegar a una ruta.
     * TODO: cuando se implementen route animations en MobileLayoutComponent,
     * revisar si este método sigue siendo necesario o si el coordinado
     * drawer-close + route-enter lo gestiona la propia animación de ruta. */
    closeInstant(): void { this._isOpen.set(false); }
}
